import { AdminBookingWebService } from '@linktivity/gds-neo';

export const BookingFreezeBatchStatus =
  AdminBookingWebService.BookingFreezeBatchModelStatus;
export type BookingFreezeBatchStatus =
  AdminBookingWebService.BookingFreezeBatchModelStatus;
export const BookingFreezeOperationAction = AdminBookingWebService.Action;
export type BookingFreezeOperationAction = AdminBookingWebService.Action;
export const BookingFreezeAction = AdminBookingWebService.FreezeAction;
export type BookingFreezeAction = AdminBookingWebService.FreezeAction;
